import axios from 'axios'
import { getContentType } from './api.helpers'

const API_URL = `${process.env.REACT_APP_BASE_URL}`

export const axiosClassic = axios.create({
	baseURL: API_URL,
	headers: getContentType(),
})
